import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function NotFound() {
  useDocumentMeta({
    title: '页面不存在 - 91吃瓜',
    description: '你访问的页面不存在，返回 91吃瓜 首页继续浏览娱乐新闻与网络热点。',
  });

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
      <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
        <span className="w-6 h-[2px] bg-primary-500" />
        ERROR 404
      </span>
      <h1 className="mt-4 font-heading font-black text-5xl md:text-7xl text-foreground-950 leading-none">
        404
      </h1>
      <p className="mt-5 font-heading font-bold text-lg md:text-xl text-foreground-800">
        这个瓜好像不在这里
      </p>
      <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md mx-auto">
        你访问的页面可能已经被移除、改名，或者链接有误。回到首页，继续看看今天的热闹吧。
      </p>
      <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category/hot"
          className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-md bg-background-100 text-foreground-800 border border-background-200 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-fire-line" />
          看看网络热点
        </Link>
      </div>
    </div>
  );
}